module.exports = __webpack_public_path__ + "static/media/Gallary4.dfa17d2e.webp";